import React, { useContext } from 'react';
import Logo from "./Logo";
import {SettingsContext} from "@/SettingsContext";
import { Bars2Icon } from "@heroicons/react/24/outline";
import InventoryButton from "@/components/game/InventoryButton";

const Header =({ toggleMenu }) => {

    const { tourSettings } = useContext(SettingsContext);

    const tourModules = tourSettings?.modules ?? []

    return (
            <div className="p-2 px-4" style={{
                backgroundColor: (tourSettings?.header_background_color) ? tourSettings.header_background_color : '#ffffff',
                color: `${ (tourSettings.header_text_color) ? tourSettings.header_text_color : '#000000'}`
            }}>


                <div className="flex ">
                    <div className="flex-grow">
                        <div className="flex h-16 items-center">
                            <Logo/>
                        </div>
                    </div>

                    {tourModules.includes('game') &&
                        <div className=" flex h-16 items-center">
                            <InventoryButton/>
                        </div>
                    }

                    {tourSettings.id && (tourSettings.introduction_page_id || tourSettings.languages?.length > 1) &&
                        <div className="flex">
                            <div className=" flex h-16 items-center">
                                <div
                                    className="rounded-full p-3 hover:cursor-pointer flex flex-col text-sm items-center ml-4"
                                    style={{"background": (tourSettings?.header_background_contrast_color) ? tourSettings.header_background_contrast_color : '#f3f4f6'}}
                                    onClick={toggleMenu}>
                                    <Bars2Icon className="h-6 w-6 cursor-pointer"/>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

    );
}

export default Header;